import _ from 'lodash';

export const getPrivacyUrl = (market, version = 2) => {
    if (!_.includes(['sk', 'cz'], market)) {
        market = 'en';
    }

    const version_suffix = version > 1 ? `-v${version}` : '';

    return `/privacy-${market}${version_suffix}.html`;
};
